<div class="container-fluid h-100 d-flex flex-column">
  <div class="title-display">
    <h2 class="title-center">Integration Error Report</h2>
  </div>
  @if (integrationsMap !== undefined && clients !== undefined && !gettingClients && reportConstants !== undefined) {
    <app-report-error-search-filter #reportErrorsFilter [reportConstants]="reportConstants"
      [errorSearchFilter]="errorSearchFilter" (updateFilter)="filterErrorsReport($event)"
      (clearGridFilters)="clearFilters($event)" (reloadCurrentList)="reloadGridForFullPopulation($event)">
    </app-report-error-search-filter>
    <div class="row">
      @if(!errorsPopulated){
        <div class="loading-display">
          <app-lt-spinner></app-lt-spinner>
        </div>
      }
      @if (this.errorsPopulated && this.firstGroupReturned) {
        <div class="mt-2">
          <app-lt-errors-grid #reportErrorsGridComponent
            [data]="fullErrorsList" 
            [destinations]="reportConstants.destinationEndpoints" 
            [integrationsMap]="integrationsMap"
            [categories]="reportConstants.errorCategories" 
            [importTypes]="reportConstants.importTypes"
            [statuses]="reportConstants.currentStatuses" 
            [loading]="dataLoading"
            [clients]="clients"
            (errorUpdated)="handleUpdatedIntegrationErrorFromGrid($event)">
          </app-lt-errors-grid>
        </div>
      }
    </div>
  }
</div>
